import React from 'react';
import MainHero from './components/mainhero/mainhero';
import KtempleNav from './components/ktempleNav/ktempleNav';
import HomeBanner from './components/homeBanner/homeBanner';
import Footer from './components/Footer/Footer';
import VisitingTemple from './components/VisitingTemple/VisitingTemple';
import KnowMoreTemple from './components/knowMoreTemple/knowMoreTemple';
import CustomBanner from './components/Banner/customBanner';

function App() {

  return (
    <>
      <KtempleNav />
      <CustomBanner sideText={"Help - Temple Renovation"} sideText2={"Donate/Volunteer"} slideUrl={"/donate"}/>
      <MainHero />
      <HomeBanner />
      <KnowMoreTemple />
      <VisitingTemple />
      <Footer />
    </>
  )
}

export default App
